import {
  AsYouType,
  getCountries,
  getCountryCallingCode,
} from "libphonenumber-js";

const DIAL_CODES = new Set(getCountries().map((c) => getCountryCallingCode(c)));

// True when `phone` holds a real number, not just "+" or a prefilled dial code (e.g. "+31").
export function phoneHasNumber(phone) {
  if (!phone) return false;
  phone = `${phone}`.trim();
  if (!phone || phone === "+") return false;
  if (phone.indexOf("+") === -1) return /[0-9]/.test(phone);
  const asYouType = new AsYouType();
  asYouType.input(phone);
  return asYouType.getNationalNumber().length > 0;
}

// Empties what PhoneInput prefills: "+", a dial code, or V3's plus-less "31".
export function phoneOrEmpty(phone) {
  const plain = `${phone ?? ""}`.trim();
  // phoneHasNumber also fails a full number with an unknown dial code.
  if (!/^\+?\d{0,3}$/.test(plain)) return phone;
  const isBare = plain.startsWith("+")
    ? !phoneHasNumber(plain)
    : DIAL_CODES.has(plain);
  return isBare ? "" : phone;
}
